import { LocaleApi } from './locale.api';

const localeApi = new LocaleApi();

export { localeApi };
